import React from 'react';
import { cn } from '@/utils';

export type NavigationTab = 'overview' | 'pipeline' | 'sequences' | 'analytics' | 'past-clients';

interface NavigationProps {
  activeTab: NavigationTab;
  onTabChange: (tab: NavigationTab) => void;
}

export const Navigation: React.FC<NavigationProps> = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'overview' as NavigationTab, label: 'Overview', badge: null },
    { id: 'pipeline' as NavigationTab, label: 'Lead Pipeline', badge: '847' },
    { id: 'sequences' as NavigationTab, label: 'Sequence Editor', badge: null },
    { id: 'analytics' as NavigationTab, label: 'Analytics', badge: null },
    { id: 'past-clients' as NavigationTab, label: 'Past Client Monitor', badge: '23' },
  ];

  return (
    <nav className="bg-slate-800 border-b border-slate-600 h-16 flex items-center px-6">
      <div className="flex space-x-1">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={cn(
              'relative px-6 py-3 text-sm font-medium transition-colors rounded-lg',
              activeTab === tab.id
                ? 'bg-slate-700 text-white border-b-2 border-blue-500'
                : 'text-slate-300 hover:text-white hover:bg-slate-700'
            )}
          >
            {tab.label}
            {tab.badge && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                {tab.badge}
              </span>
            )}
          </button>
        ))}
      </div>
    </nav>
  );
};